import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: 'input[decimalOnly]'
})

export class DecimalDirective {

    constructor(private _el: ElementRef) { }

        @HostListener('keypress', ['$event']) onInputChange(e) {

             const charCode = e.keyCode;

        if (
            (charCode !== 46 || e.currentTarget.value.indexOf('.') !== -1) &&
            (charCode < 48 || charCode > 57)) {
            return false;
        }
        if (e.currentTarget.value != null || e.currentTarget.value !== '') {
            const result = e.currentTarget.value.split('.');
            if (result.length > 1) {
                if (result[1].length >= 2) {
                    return false;
                }
            }
        }
        if (e.currentTarget.value === '0' && e.keyCode === 48) {
            return false;
        }

    }

}
